import { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

type ReactRouterLocation = ReturnType<typeof useLocation>

type MakeRedirectPageOptions = { injectBrandId: boolean }
export const makeRedirectPage = (to: string | ((location: ReactRouterLocation) => string), { injectBrandId }: MakeRedirectPageOptions) => {
    let urlFormatter: ((location: ReactRouterLocation) => string) | undefined
    if (typeof to === 'function') {
        urlFormatter = to
    } else if (typeof to === 'string' && injectBrandId) {
        urlFormatter = (location) => {
            return useMemo(() => {
                const toSearchParams = new URLSearchParams(to.includes('?') ? to.replace(/[^?]+/, '') : '')
                const brandId = new URLSearchParams(location.search).get('brandId')
                if (brandId) {
                    toSearchParams.set('brandId', brandId)
                }
                return `${to.replace(/\?.+/, '')}?${toSearchParams.toString()}`
            }, [location.pathname])
        }
    } else {
        urlFormatter = () => to
    }
  return () => {
    const location = useLocation()
    const url = urlFormatter(location)
    console.log('redirecting to', url)
    return <Navigate to={url} replace />
  }
}
